const SecurityGovernance = ({ title, description, data }: { title: string, description: string, data: { tags?: string[] } }) => {
    return (
        <section
            className="desilo-service6-section section-padding-top overflow-hidden"
            id="service-section"
        >
            <div className="container custom-container">
                <div className="row gx-4 gy-5">
                    <div className="col-12">
                        <div className="desilo__header text-left text-lg-start">
                            <h2 className="title">
                                {title}
                            </h2>
                            <p className="hero2-content-text">
                                {description && description}
                            </p>
                            <div className="blog-item">
                                <div className="blog-tags mt-0">
                                    <ul className="custom-ul">
                                        {data?.tags?.map((tag, index) => (
                                            <li key={index}>
                                                <span className="service-tags">{tag}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecurityGovernance;